import { Flex, Image, Select, Td, Text } from "@chakra-ui/react";
import MinusSqaureIcon from "assets/minus-square-icon.svg";
import PlusSquareIcon from "assets/plus-square-icon.svg";
import { status } from "config/Consts";
import { useEffect, useState } from "react";
import InputCol from "./InputCol";

const selectOptions: any = {
  status: [...status.slice(2)],
  hoursPerWeek: ["20 hours", "30 hours", "40 hours", "50 hours"],
  hourlyPay: ["$ 9", "$ 15", "$ 18", "$ 20"],
};

const RenderColumns = ({
  value,
  isOpen,
  handleOpen,
  setPayload,
  hpw,
  setHpw,
  prop,
  idx,
  jobObj,
  href,
}: {
  value: any;
  isOpen: boolean;
  handleOpen: (arg?: any) => void;
  setPayload: (arg?: any) => void;
  hpw: number | string | undefined;
  prop: string;
  setHpw: (arg?: any) => void;
  idx: number;
  jobObj: any;
  href: string;
}): JSX.Element => {
  const [inputValue, setInputValue] = useState<string>();
  const [color, setColor] = useState("black");
  const handleSelection = (e: any): void => {
    setPayload({ fieldName: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    setInputValue(value);
    if (value as boolean) setColor("gray");
  }, [value]);

  return (
    <>
      <Td
        key={prop}
        sx={{
          "&:nth-of-type(4), &:nth-of-type(5)": {
            maxW: "150px",
          },
          "& input": {
            maxWidth: "100%",
            width: "180px",
          },
        }}
      >
        <Flex gap={2} alignItems="center">
          {idx === 0 && (
            <Image
              src={isOpen ? MinusSqaureIcon : PlusSquareIcon}
              alt="/minus icon"
              onClick={() => handleOpen((prev: boolean) => !prev)}
              _hover={{
                cursor: "pointer",
              }}
            />
          )}
          {idx >= 2 && idx <= 4 ? (
            idx === 3 ? (
              <InputCol
                prop={prop}
                setInputValue={setHpw}
                inputValue={hpw}
                handleSelection={(e) => {
                  setPayload({
                    fieldName: e.target.name,
                    value: e.target.value,
                  });
                }}
              />
            ) : idx === 4 ? (
              <InputCol
                prop={prop}
                setInputValue={setInputValue}
                inputValue={inputValue}
                handleSelection={handleSelection}
              />
            ) : (
              <Select
                variant="unstyled"
                name={prop}
                value={value ?? ""}
                onChange={handleSelection}
              >
                {selectOptions[prop]?.map((option: any, idx: number) => (
                  <option key={idx}>{option}</option>
                ))}
              </Select>
            )
          ) : (
            <Text
              maxW={400}
              lineHeight="1.6rem"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {href?.length > 0 ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:underline"
                >
                  {value}
                </a>
              ) : (
                value
              )}
            </Text>
          )}
        </Flex>
      </Td>
    </>
  );
};

export default RenderColumns;
